import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ShgnFooterMark from 'images/icons/shgn/ShgnFooterMark.svg'
import { ConfigConsumer } from 'contexts/config-context'
import { SettingsConsumer } from 'contexts/settings-context'
import { ThemeConsumer } from '../../../contexts/theme-context'

const Wrapper = styled.div`
  display: flex;
  flex-flow: ${(p) => (p.isMobile ? 'column' : 'null')};
  justify-content: ${(p) => (p.isMobile ? 'center' : 'space-between')};
  align-items: ${(p) => (p.isMobile ? 'center' : 'flex-end')};
  height: ${(p) => (p.isMobile ? 'auto' : '52px')};
  border-bottom: 1px solid rgba(204, 205, 206, 1);
`

const ItemsList = styled.ul`
  display: flex;
  align-items: ${(p) => (p.isMobile ? 'center' : 'null')};
  flex-flow: ${(p) => (p.isMobile ? 'column' : 'null')};
  margin: ${(p) => (p.isMobile ? '15px auto 4px auto' : '0 0 12px 12px')};
  padding: 0;
`

const NavItem = styled.li`
  display: inline-block;
  padding: ${(p) => (p.isMobile ? '0 0 22px 0' : '0 0 0 24px')};
  font-family: 'Arial';
  font-size: 14px;
`

const ShgnLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(p) => (p.isMobile ? ' 0 0 24px 0' : '0 36px 6px 0')};
  width: 217px;

  img {
    width: 100%;
  }
`

const A = styled.a`
  text-decoration: none;
`

const StyledLink = styled.div`
  color: rgba(50, 50, 50, 1);
`

const GamblingMessage = styled.div`
  color: rgba(48, 48, 48, 1);
  font-family: 'Arial';
  font-size: 12px;
  margin-top: 8px;
  margin-left: ${(p) => (p.isMobile ? null : '36px')};
  text-align: ${(p) => (p.isMobile ? 'center' : null)};
`

function ExpandedGamblingDisclaimer({ isMobile }) {
  return (
    <GamblingMessage isMobile={isMobile}>
      Visit our{' '}
      <a href="https://terms.fanball.com/termsandprivacy/responsibleplay" target="_blank" rel="noopener noreferrer">
        Responsible Gaming resource center
      </a>{' '}
      to ensure you have all the support you need to maintain a responsible, safe, and enjoyable fantasy gaming
      experience. If you or someone you know has a gambling problem and wants help, call{' '}
      <a href="tel:18004262537">1-800-GAMBLER</a>. Use the following resources for additional help: MA use{' '}
      <a href="https://gamblinghelplinema.org" target="_blank" rel="noopener noreferrer">
        GamblingHelpLineMA.org
      </a>{' '}
      or call <a href="tel:18003275250">1-800-327-5050</a>; NY call <a href="tel:18778467369">1-877-8HOPE-NY</a> or Text
      HOPENY to 467369; AZ (
      <a href="https://problemgambling.az.gov/" target="_blank" rel="noopener noreferrer">
        problemgambling.az.gov
      </a>
      ), or call{' '}
      <a href="tel:18008006785" target="_blank" rel="noopener noreferrer">
        1-800-NEXT-STEP
      </a>
      ; CO, IL, IA, KY, MI, NJ, OH, PA, TN, VA call <a href="tel:18004262537">1-800-GAMBLER</a>; IN call{' '}
      <a href="tel:18009944448" target="_blank" rel="noopener noreferrer">
        1-800-9-WITH-IT
      </a>
      ; KS call 1-800-522-4700 or visit{' '}
      <a href="https://ksgamblinghelp.com" target="_blank" rel="noopener noreferrer">
        ksgamblinghelp.com
      </a>
      ; MD visit{' '}
      <a href="http://www.mdgamblinghelp.org" target="_blank" rel="noopener noreferrer">
        www.mdgamblinghelp.org
      </a>
      ; WY call 1-800-522-4700; WV visit{' '}
      <a href="https://www.1800gambler.net" target="_blank" rel="noopener noreferrer">
        www.1800gambler.net
      </a>
      . You must be 18+ to play (19+ in AL & NE and 21+ in AZ, IA, LA & MA). Account sharing is prohibited.
    </GamblingMessage>
  )
}

ExpandedGamblingDisclaimer.propTypes = {
  isMobile: PropTypes.bool,
}

function FooterLinks(props) {
  const { isMobile } = props
  return (
    <React.Fragment>
      <Wrapper isMobile={isMobile}>
        <ItemsList isMobile={isMobile}>
          <ConfigConsumer>
            {(config) =>
              config.footerItems &&
              config.footerItems.map((navItem, index) => {
                return (
                  <NavItem key={index} isMobile={isMobile}>
                    <A href={navItem.url}>
                      <StyledLink>{navItem.text}</StyledLink>
                    </A>
                  </NavItem>
                )
              })
            }
          </ConfigConsumer>
        </ItemsList>
        <SettingsConsumer>
          {(settings) => {
            return (
              <ShgnLogo isMobile={isMobile}>
                <A href="https://www.shgn.com/">
                  <img src={`${settings.HOSTNAME}${ShgnFooterMark}`} alt="SportsHub Games Network" />
                </A>
              </ShgnLogo>
            )
          }}
        </SettingsConsumer>
      </Wrapper>
      <ThemeConsumer>
        {(theme) => theme.requiresGamblingMessage && <ExpandedGamblingDisclaimer isMobile={isMobile} />}
      </ThemeConsumer>
    </React.Fragment>
  )
}

FooterLinks.propTypes = {
  isMobile: PropTypes.bool,
}

export default FooterLinks



// WEBPACK FOOTER //
// ./src/organisms/Footer/components/FooterLinks.js